export default __webpack_public_path__ + "4d1cb903191c506b27f68240bce0e6de.svg";